import { Dispatch, SetStateAction } from 'react';
import { AccountType } from '@nextgen-web-framework/all';
import type {
  RegFlowConfig,
  RegistrationNextHandlerPatchPayload,
  DynamicObjectInterface,
  onSuccessPropType,
  TermsConditionResult,
  AccountTypeImagesResult,
  ProfileImagesResult,
  Step,
  IRegistrationOrderConfirmationImages,
} from '@commerce-profile-webcomponents/sdk';

export type NextHandlerProps = RegistrationNextHandlerPatchPayload | undefined | null;

export interface RegistrationCommonProps {
  nextHandler: (
    payload?: NextHandlerProps,
    slicePayload?: DynamicObjectInterface,
    stayOnSameStep?: boolean,
    callOnSuccess?: boolean,
    apiCallType?: APICallType,
  ) => DynamicObjectInterface;
  setSubmitHandler?: Dispatch<SetStateAction<Function | undefined>>;
}

export interface RegistrationProps {
  findOutMoreUrl: string;
  sourceUrl: string;
  redirectUrl: string;
  onSuccess: ({ registrationId, accountType, kitSku, useNewCartForCheckout, returnUrl }: onSuccessPropType) => void;
  flowName: RegFlowConfig;
  accountType?: AccountType;
  sponsorNumber?: string;
  sponsorName?: string;
  //removed once e2e replace completeYourProfileUrl with redirectUrl
  completeYourProfileUrl?: string;
  // Added for co-app
  stepName?: string;
  registrationId?: string;
  backHandler?: () => void;
  profileInfoCms?: ProfileImagesResult;
  accountTypeImagesCms?: AccountTypeImagesResult[];
  termsAndConditionsCms?: TermsConditionResult[];
  registrationOrderConfirmImagesCMS?: IRegistrationOrderConfirmationImages[];
  setSubmitHandler?: Dispatch<SetStateAction<Function | undefined>>;
}
export interface IdentityOnInputChangeCallbackResponse {
  countryCode?: string;
  amwayId?: string;
  emailOrPhoneWithoutCC?: string;
}
export enum APICallType {
  DEFAULT = 'DEFAULT',
  SKIP = 'SKIP',
  PATCH = 'PATCH',
}
export interface GenericErrorType {
  headline?: string;
  body?: string;
  callback?: () => void;
  buttonLabel?: string;
  buttonCallback?: () => void;
}
export interface StepType extends Step {
  stepName?: string;
}

export type IFieldVisibility = { [key: string]: boolean };
